import React from 'react'
import styled from 'styled-components'
import Sidebar from 'shared/components/user/sidebar'
import VideoPlayer from 'shared/components/video-prototype/player'
import { IVideoGif } from 'shared/components/video-prototype/types'
import Tags from 'shared/components/tags/tags'

const Container = styled.div`
    display: flex;
    padding-top: 30px;
    position: relative;
    width: 100%;
`

const Content = styled.div`
    position: relative;
`

const VideoWrapper = styled.div`
    margin-bottom: 24px;
`

type Props = {
    gif: IVideoGif
}

const VideoDetailPrototype = ({ gif }: Props) => {
    const { user, tags = [] } = gif
    return (
        <Container>
            <Sidebar user={user} showSearch={false} showDashboardLink={false} />
            <Content>
                <VideoWrapper>
                    <VideoPlayer video={gif} />
                </VideoWrapper>
                {tags.length > 0 && <Tags tags={tags} isSticker={false} />}
            </Content>
        </Container>
    )
}

export default VideoDetailPrototype
